




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'badge-logofscpfsc-component',
})
export default class LogoFscPfscComponent extends Vue {
}
